import React from 'react';

const StudentView = () => {
  return (
    <div className="student-view">
      <h1>Student View</h1>
      <p>This is the student view component.</p>
    </div>
  );
};

export default StudentView;
